import * as EmailValidator from 'email-validator';
import tlds from 'tlds';

export const MENSAGEM_EMAIL_PAGAMENTO_INVALIDO =
  'Informe um e-mail válido. Confira o domínio, por exemplo: gmail.com.';

export function normalizeEmailPagamento(email: any): string {
  return email === null || email === undefined ? '' : String(email).trim();
}

export function emailPagamentoValido(email: any): boolean {
  const emailNormalizado = normalizeEmailPagamento(email);

  if(!EmailValidator.validate(emailNormalizado))
    return false;

  const dominio = emailNormalizado.substring(emailNormalizado.lastIndexOf('@') + 1).toLowerCase();
  const tld = dominio.substring(dominio.lastIndexOf('.') + 1);

  return tlds.indexOf(tld) >= 0;
}
